var render = function render(){
  var _vm$getAuthAppBrandin, _vm$getAuthAppBrandin2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auth-branding-tab"
  }, [_c('div', {
    staticClass: "scroll-ctn"
  }, [_c('v-btn', {
    staticClass: "phone-preview-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.expandPreview
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-cellphone")])], 1), _c('div', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_branding')) + " ")]), _c('div', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_customize_ui'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('auth_tab_customize_note')) + " ")]), _c('div', {
    staticClass: "font-weight-bold mt-6"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_logo_label')))]), _c('br'), _c('span', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_logo_description')))])]), _c('v-row', {
    staticClass: "mt-4 ml-0",
    attrs: {
      "flex": ""
    }
  }, [_vm.isPreviewImage ? _c('v-btn', {
    staticClass: "border",
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.uploadImageModal = !_vm.uploadImageModal;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_select_image')) + " ")]) : _vm._e(), (_vm$getAuthAppBrandin = _vm.getAuthAppBranding) !== null && _vm$getAuthAppBrandin !== void 0 && _vm$getAuthAppBrandin.logo ? _c('div', {
    staticClass: "imagePreview ml-2"
  }, [_c('img', {
    attrs: {
      "src": (_vm$getAuthAppBrandin2 = _vm.getAuthAppBranding) === null || _vm$getAuthAppBrandin2 === void 0 ? void 0 : _vm$getAuthAppBrandin2.logo,
      "alt": "brand logo"
    }
  }), _c('v-btn', {
    staticClass: "remove",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.removeModal = true;
      }
    }
  }, [_c('v-icon', [_vm._v("$remove")])], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "font-weight-bold mt-6"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_background_color_label')))]), _c('br'), _c('span', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_background_color_description')))])]), _c('color-input', {
    staticClass: "pa-3 pl-0",
    attrs: {
      "color": _vm.background
    },
    on: {
      "update:color": function updateColor($event) {
        _vm.background = $event;
      }
    }
  }), _c('div', {
    staticClass: "font-weight-bold mt-6"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_primary_color_label')))]), _c('br'), _c('span', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_primary_color_description')))])]), _c('color-input', {
    staticClass: "pa-3 pl-0",
    attrs: {
      "color": _vm.primaryColor
    },
    on: {
      "update:color": function updateColor($event) {
        _vm.primaryColor = $event;
      }
    }
  }), _c('div', {
    staticClass: "font-weight-bold mt-6"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_secondary_color_label')))]), _c('br'), _c('span', {
    staticClass: "font-weight-light pa-3 pl-0"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_secondary_color_description')))])]), _c('color-input', {
    staticClass: "pa-3 pl-0",
    attrs: {
      "color": _vm.secondaryColor
    },
    on: {
      "update:color": function updateColor($event) {
        _vm.secondaryColor = $event;
      }
    }
  })], 1), _vm.isAdmin ? _c('div', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "advanced-setup",
    on: {
      "click": function click($event) {
        _vm.showAdvancedSetup = !_vm.showAdvancedSetup;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_advanced_setup')) + " "), _c('v-icon', {
    staticClass: "arrow-icon",
    attrs: {
      "large": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.showAdvancedSetup ? 'mdi-menu-up' : 'mdi-menu-down') + " ")])], 1), _vm.showAdvancedSetup ? _c('div', {
    staticClass: "mt-9"
  }, [_c('div', {
    staticClass: "d-flex flex-column mb-5"
  }, [_c('div', {
    staticClass: "label font-weight-bold mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_landing_page_key')) + " ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    staticClass: "mr-2 max-w-200",
    attrs: {
      "value": _vm.getLPKey,
      "disabled": "",
      "hide-details": "",
      "dense": ""
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              return _vm.copyToClipboard(_vm.getLPKey);
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-content-copy")])], 1)];
      }
    }], null, false, 228672712)
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('auth_tab_copy_key')))])])], 1)]), _c('div', [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_force_default_language_label')) + " ")]), _c('p', {
    staticClass: "my-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_force_default_language_description1'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('auth_tab_force_default_language_description2')) + " ")]), _c('v-col', {
    staticClass: "d-flex pl-0",
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": [{
        name: 'None',
        key: ''
      }].concat(_vm.languages),
      "item-text": "name",
      "item-value": "key",
      "label": _vm.$t('auth_tab_device_language'),
      "solo": ""
    },
    on: {
      "change": function change($event) {
        return _vm.updateAdvancedSettings();
      }
    },
    model: {
      value: _vm.advancedSettings.forceDefaultLanguage,
      callback: function callback($$v) {
        _vm.$set(_vm.advancedSettings, "forceDefaultLanguage", $$v);
      },
      expression: "advancedSettings.forceDefaultLanguage"
    }
  })], 1)], 1), _c('div', [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_torch_control_label')) + " ")]), _c('p', {
    staticClass: "my-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('auth_tab_torch_control_description'))), _c('br'), _c('span', {
    staticClass: "alert"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_torch_control_alert')))])]), _c('v-col', {
    staticClass: "d-flex pl-0",
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.torchOptions,
      "item-text": "name",
      "item-value": "value",
      "solo": ""
    },
    on: {
      "change": function change($event) {
        return _vm.updateAdvancedSettings();
      }
    },
    model: {
      value: _vm.advancedSettings.torchControlInVideoAuth,
      callback: function callback($$v) {
        _vm.$set(_vm.advancedSettings, "torchControlInVideoAuth", $$v);
      },
      expression: "advancedSettings.torchControlInVideoAuth"
    }
  })], 1)], 1)]) : _vm._e()]) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.removeModal,
      callback: function callback($$v) {
        _vm.removeModal = $$v;
      },
      expression: "removeModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('delete_confirmation')))]), _c('v-card-text', [_c('div', {
    staticClass: "my-5"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('auth_tab_delete_confirmation_text')))])])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.removeModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "error"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v(_vm._s(_vm.$t('remove')))])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.uploadImageModal,
      callback: function callback($$v) {
        _vm.uploadImageModal = $$v;
      },
      expression: "uploadImageModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('auth_tab_select_image')))]), _c('v-card-text', [_c('div', {
    staticClass: "my-5 d-flex justify-space-around align-center g"
  }, [_c('image-cropper', {
    attrs: {
      "input-key": "brand-logo",
      "hide-tooltip": true
    },
    on: {
      "image-upload": _vm.handleSTGallerySelected
    }
  }), _vm.isAllowed('gallery_view') ? _c('div', {
    staticClass: "cursor-pointer d-flex flex-column justify-center align-center",
    on: {
      "click": function click($event) {
        _vm.displaySTGalleryDialog = true;
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "accent",
      "icon": "",
      "x-large": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-image-outline")])], 1), _c('span', [_vm._v(_vm._s(_vm.$t('translations_select_image')))])], 1) : _vm._e()], 1)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.uploadImageModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1)], 1)], 1), _c('select-image-dialog', {
    attrs: {
      "display-select-image-dialog": _vm.displaySTGalleryDialog,
      "app-tags": ['ulbs-editor-company-logo'],
      "isAllowedEdit": _vm.isAllowed('gallery_edit')
    },
    on: {
      "update:displaySelectImageDialog": function updateDisplaySelectImageDialog($event) {
        _vm.displaySTGalleryDialog = !_vm.displaySTGalleryDialog;
      },
      "gallery-selected": _vm.handleSTGallerySelected
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }